<template>
  <div class="organisation-info-wrapper relative" >
    <div
      class="organisation-info flex flex-align-center ellipsis"
      :class="{
        'child-icon-active': organisationMenuOpened | hovering,
        'single': organisationList.length <= 1,
      }"
      title="Toggle menu"
      @click="toggleMenuDropdown"
      @mouseover="hovering = true"
      @mouseout="hovering = false">
      <span
        v-if="currentOrganisation.logo && currentOrganisation.logo !== ''"
        class="organisation-logo round-wrap no-shrink"
        :style="`background-image: url(${currentOrganisation.logo});`" />
      <SBIcon
        v-else
        class="org-logo"
        :icon="SBIconList.BUSINESS"
        :color="SBColors.white"
        background-color="#9EAEB5"
        :border-radius="100"
        :size="10"
        :hover-size="20" />
      <span class="name ellipsis">{{ currentOrganisation.name }}</span>
      <SBIcon
        v-if="organisationList.length > 1"
        class="arrow"
        :icon="SBIconList.DOWN_ARROW"
        :color="SBColors.greyPrimary"
        :hover-icon-color="SBColors.blackPrimary"
        :size="12" />
    </div>

    <div
      v-if="organisationMenuOpened"
      v-click-outside="closeMenuDropdown"
      class="floating-menu" >

      <!-- TODO when we enable adding organisations then uncomment this section and add logic -->
      <!-- <span class="new-organisation flex center-all">
        <SBIcon
          id="new-org-icon"
          :icon="SBIconList.PLUS_THIN"
          :color="SBColors.bluePrimary"
          :size="12"
          hover-color="#f7f9fb"
          :hover-size="24"
          @click="() => {}" />
        <b-popover
          target="new-org-icon"
          custom-class="basic-popover"
          triggers="hover"
          placement="top"
          :delay="{ show: 200, hide: 0 } " >
          Add new organisation.
        </b-popover>
      </span> -->

      <SearchableList
        title="Select organisation"
        :item-list="organisationList"
        :filter-fn="(searchTerm) => { return item => item.name && item.name.toLowerCase().indexOf(searchTerm) !== -1;}"
        :no-focus="true"
        class="searchable-list"
        @item-selected="selectOrganisation">
        <template #default="slotProps">
          <!-- Router link is disabled because there are some issues while changing org so this is the quick fix to reload the whole page. Fix this when more time will be available. -->
          <!-- <router-link
            :to="{ name: 'OrganisationWithId', params: { organisationId: slotProps.item.id, clearConversationCache: true }}"
            tag="div"
            class="greedy sb2-dropdown-item flex flex-align-center w-100"> -->
          <div
            class="greedy sb2-dropdown-item flex flex-align-center w-100" >
            <span
              v-if="slotProps.item.logo !== ''"
              class="org-logo in-list"
              :style="`background-image: url(${slotProps.item.logo});`" />
            <SBIcon
              v-else
              class="org-logo"
              :icon="SBIconList.BUSINESS"
              :color="SBColors.white"
              background-color="#9EAEB5"
              :border-radius="100"
              :size="10"
              :hover-size="20" />
            <span
              class="title-wrap greedy ellipsis"
              :inner-html.prop="slotProps.item.name | boldMatch(slotProps.searchTerm)" />
            <SBIcon
              v-if="currentOrganisation.id === slotProps.item.id"
              :icon="SBIconList.DONE_TICK"
              :color="SBColors.bluePrimary"
              :size="9" />
          </div>
          <!-- </router-link> -->
        </template>
      </SearchableList>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import SearchableList from '@/components/common/SearchableList';

export default {
  name: 'SelectOrganisation',
  components: {
    SBIcon,
    SearchableList,
  },
  data() {
    return {
      organisationMenuOpened: false,
      hovering: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisation: 'organisation/currentOrganisation',
      organisationList: 'organisation/organisationList',
      myId: 'user/id',
    }),
  },
  methods: {
    ...mapActions({
      setOrganisationSplash: 'organisation/setOrganisationSplash',
      getOrgInfo: 'organisation/getOrgInfo',
    }),
    ...mapMutations({
      CURRENT_ORGANISATION_SET_DATA: 'organisation/CURRENT_ORGANISATION_SET_DATA',
    }),
    closeMenuDropdown() {
      this.organisationMenuOpened = false;
    },
    selectOrganisation(selectedOrganisation) {
      if (selectedOrganisation.id === this.currentOrganisation.id) {
        this.toggleMenuDropdown();
      } else {
        // Clear local storage for previous organisation, number and conversation
        localStorage.setItem('lastOrganisationInFocus', JSON.stringify({ [this.myId]: selectedOrganisation.id }));
        localStorage.removeItem('lastConversationInFocus');
        localStorage.removeItem('lastBusinessInFocus');
        this.$nextTick(() => {
          window.location.href = '/';
        });

        // this.setOrganisationSplash({ message: 'Getting everything ready...' });
        // this.getOrgInfo(selectedOrganisation.id);
        // this.$nextTick(() => {
        //   this.$router.push({
        //     name: 'OrgContacts',
        //     params: {
        //       organisationId: selectedOrganisation.id,
        //     },
        //   }).catch(() => {});
        //   this.CURRENT_ORGANISATION_SET_DATA(selectedOrganisation);
        //   this.toggleMenuDropdown();
        // });
      }
    },
    toggleMenuDropdown() {
      if (this.organisationList.length <= 1) {
        this.organisationMenuOpened = false;
        return;
      }
      this.organisationMenuOpened = !this.organisationMenuOpened;
    },
  },
};
</script>

<style lang="scss" scoped>
.organisation-info-wrapper {
  max-width: 100%;
  min-width: 0;

  .organisation-info {
    margin: 0;
    padding: 5px 7px;
    border-radius: 50px;
    // max-width: max-content;
    cursor: default;
    .organisation-logo {
      width: 28px;
      height: 28px;
      display: inline-block;
      background-size: cover;
      border-radius: 100%;
      border: solid 1px #d2d4d9;
    }

    .name {
      font-size: 14px;
      font-weight: bold;
      color: $blackPrimary;
      margin-left: 13px;
    }

    .arrow {
      margin-left: 6px;
    }

    &:not(.single):hover {
      cursor: pointer;
    }
  }

  .floating-menu {
    overflow: hidden;
    position: absolute;
    width: 299px;
    z-index: 999999;
    margin: 2px;
    border-radius: 5px;
    box-shadow: 0 2px 5px 0 rgba(13, 15, 22, 0.23);
    background-color: $white;

    .new-organisation {
      position: absolute;
      right: 10px;
      top: 11px;
      font-size: 14px;
      font-weight: 500;
      color: $bluePrimary;
      z-index: 100;
      cursor: pointer;

      .sb-icon {
        margin-right: 0px;
      }

      &:hover {
        color: $blackPrimary;

        ::v-deep .sb-icon span.icon.mask {
          background-color: $blackPrimary !important;
        }
      }
    }

    .searchable-list {
      .org-logo {
        width: 18px;
        height: 18px;
        background-position: center;
        background-size: cover;
        border-radius: 100px;

        &.in-list {
          width: 20px;
          height: 20px;
        }
      }
    }

    ::v-deep .search-results-list {
      li {
        padding: 8px 15px;

        &:hover {
          cursor: pointer;
        }

        .org-logo {
          margin-right: 8px;
        }
      }
    }
  }

  &.top-layer {

    .organisation-info {
      padding: 5px 10px 5px 7px;
    }
  }
}
</style>
